import { useEffect, useState } from 'react';

export const createUseResetPassword = (userService) => () => {
  const [passwordResetEmail, setPasswordResetEmail] = useState<string>('');
  const [resetState, setResetState] = useState<{
    errorPasswordResetEmail: string | undefined;
    success: boolean;
  }>({ errorPasswordResetEmail: undefined, success: false });

  const handleResetPassword = async () => {
    try {
      await userService.sendPasswordResetEmail(passwordResetEmail);

      setResetState({ errorPasswordResetEmail: undefined, success: true });
    } catch (error: any) {
      setResetState({
        errorPasswordResetEmail: error?.code || 'default',
        success: false,
      });
    }
  };

  useEffect(() => {
    setResetState({ errorPasswordResetEmail: undefined, success: false });
  }, [passwordResetEmail]);

  return {
    passwordResetEmail,
    errorPasswordResetEmail: resetState.errorPasswordResetEmail,
    handleResetPassword,
    setPasswordResetEmail,
    success: resetState.success,
  };
};
